import React, { useState, useRef, useContext } from 'react';
import { AuthContext } from '../../AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export const TwoFaVerification = () => {
  const [otp, setOtp] = useState(Array(6).fill(''));
  const [error, setError] = useState('');
  const { tempToken, setTempToken, login } = useContext(AuthContext);
  const navigate = useNavigate();
  const inputRefs = useRef([]);

  const handleChange = (value, index) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    const code = otp.join('');

    try {
      const res = await axios.post(
        '/auth/verify-2fa-login',
        { token: code },
        {
          headers: {
            Authorization: `Bearer ${tempToken}`,
          },
        }
      );

      const data = res.data;
      login(data.token, data.user, data.featureAccess);
      setTempToken('');
      navigate('/');
    } catch (err) {
      console.error('2FA verification failed:', err);
      setError('Invalid 2FA code. Please try again.');
    }
  };

  return (
    <div style={{ fontFamily: "'Inter', sans-serif" }}>
      <style>{`
        :root {
          --primary-color: #137fec;
          --background-color: #f8fafc;
          --text-color: #0f172a;
          --muted-text-color: #64748b;
          --input-border-color: #cbd5e1;
          --input-focus-border-color: var(--primary-color);
        }
        .otp-input {
          width: 3.5rem;
          height: 4rem;
          text-align: center;
          font-size: 1.5rem;
          border-radius: 0.5rem;
          border: 1px solid var(--input-border-color);
          background-color: #fff;
          color: var(--text-color);
          transition: all 0.2s ease-in-out;
        }
        .otp-input:focus {
          outline: none;
          border-color: var(--input-focus-border-color);
          box-shadow: 0 0 0 2px rgba(19, 127, 236, 0.2);
        }
      `}</style>

      <div
        style={{
          background: 'var(--background-color)',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '450px',
            padding: '2rem',
            background: '#fff',
            borderRadius: '1rem',
            boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div className="col-md-6 col-lg-5">
            <img src="vendors/images/login-page-img.png" alt="" />
          </div>

          <h1 style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>Two-Factor Authentication</h1>
          <p style={{ marginTop: '0.5rem', color: 'var(--muted-text-color)' }}>
            Enter the 6-digit code from your authenticator app.
          </p>

          <form onSubmit={handleSubmit}>
            <fieldset
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '0.75rem',
                marginTop: '1.5rem',
              }}
            >
              {otp.map((digit, index) => (
                <input
                  key={index}
                  ref={el => (inputRefs.current[index] = el)}
                  className="otp-input"
                  type="text"
                  inputMode="numeric"
                  maxLength="1"
                  value={digit}
                  onChange={e => handleChange(e.target.value, index)}
                  onKeyDown={e => handleKeyDown(e, index)}
                  required
                />
              ))}
            </fieldset>

            <button
              className="btn btn-primary btn-lg btn-block"
              style={{
                marginTop: '2rem',
                width: '100%',
                padding: '0.75rem',
                borderRadius: '0.5rem',
                border: 'none',
                color: '#fff',
                fontWeight: '500',
                fontSize: '1rem',
                cursor: 'pointer',
                transition: 'background 0.2s',
                background: '#eb8d16',
              }}
            >
              Verify
            </button>
          </form>

          {error && <p style={{ marginTop: '1rem', color: 'red', fontSize: '0.9rem' }}>{error}</p>}
        </div>
      </div>
    </div>
  );
};
